'use strict';

module.exports = require('./es2016');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/es7.js
// module id = 476
// module chunks = 0